import { createFileRoute, useSearch } from '@tanstack/react-router';
import { useEffect } from 'react';
import { z } from 'zod';
import { RenegociacaoListagem } from '@/features/renegociacao/page/listagem/RenegociacaoListagem';
import { useRenegociacaoPaginationStore } from '@/features/renegociacao/store';
import { RenegociacaoTipo } from '@/features/renegociacao/types/Renegociacao';

function Component() {
    const { idpk } = useSearch({ from: '/a/renegociacao/contas-receber/' });

    useEffect(() => {
        useRenegociacaoPaginationStore.getState().setFilter({ idpk });
    }, [idpk]);

    return <RenegociacaoListagem tipo={RenegociacaoTipo.Receber} />;
}

export const Route = createFileRoute('/a/renegociacao/contas-receber/')({
    component: Component,
    validateSearch: z.object({ idpk: z.string().optional() }),
});
